import React, { useEffect, useState } from "react";
import "./Common_Form.css";

import { useForm } from "react-hook-form";
import { Col, Form, Row } from "react-bootstrap";
import classNames from "classnames";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Cookies from "js-cookie"; // Import js-cookie
// import { getData, getData2, postData } from "../../../utils/api";
import { getData, getData2, postData } from '../../../utils/api';
import { useNavigate } from "react-router-dom";
import Select from "react-select";

const Common_Form = ({ source_name }) => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const [coursesdata, setCoursesdata] = useState([]);
  const [statedata, setStatedata] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [modalsuccess, setModalsuccess] = useState(false);
  const [modalerror, setModalError] = useState(false);
  const router = useNavigate(); // Initialize navigate

  const getCityData = async (id) => {
    try {
      const res = await getData2(`/districts?state_id=${id}`);
      if (res?.success) {
        setCityData(res?.data);
      }
    } catch (error) {
      console.error("Error fetching courses data:", error);
    }
  };

  const getcoursesdata = async () => {
    try {
      const res = await getData(
        "/without-login/ed-tech/courses/common/common-type/courses",
      );
      if (res?.success) {
        setCoursesdata(res?.data);
      }
    } catch (error) {
      console.error("Error fetching courses data:", error);
    }
  };

  const getstatedata = async () => {
    try {
      const res = await getData2("/states?country_id=1");
      if (res?.success) {
        setStatedata(res?.data);
      }
    } catch (error) {
      console.error("Error fetching courses data:", error);
    }
  };

  useEffect(() => {
    getcoursesdata();
    getstatedata();
  }, []);

  const onSubmit = async (data) => {
    try {
      // Convert course_id to a number for accurate matching
      const selectedCourse = coursesdata.find(
        (course) => course.id === Number(data.course_id),
      );
      const courseName = selectedCourse ? selectedCourse.name : "Not Found"; // Default if not found

      const finalData = new FormData();
      finalData.append("name", data?.name);
      finalData.append("email", data?.email);
      finalData.append("mobile", data?.contact_no);
      finalData.append("course_name", courseName); // Send course name
      finalData.append("message", data?.message);
      finalData.append("state_id", data?.state_id);
      finalData.append("district_id", data?.district_id);
      finalData.append("api_key", process.env.REACT_APP_API_KEY);
      // finalData.append("source_name", "DY_Patil_Online_MCA");
      // finalData.append("source_name", "GoogleAds_DY_Profcyma_Mba");
      finalData.append("source_name", "Atlas_University_Google_Ads");

      const remark = `${data?.message} - Course: ${courseName}`;
      finalData.append("remark", remark);

      const response = await axios.post(
        `${process.env.REACT_APP_CRM_URL}/website-lead`,
        finalData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      const res = await postData("/without-login/ed-tech/inquiry", {
        ...data,
        course_name: courseName,
      });

      if (res?.success) {
        // console.log("Response:", res);
        Cookies.set("inquirySubmitted", true, { expires: 7 });
        reset();
        setModalsuccess(true);

        setTimeout(() => {
          const link = document.createElement("a");
          // link.href = "/assets/bwidesolutions_DPU_BROCHURE.pdf"; 
          // link.download = "Brochure.pdf"; 
          link.click();
          setModalsuccess(false);
          router("/thank-you/");
        }, 2000);
      } else {
        console.error("Error response:", res);
      }
    } catch (error) {
      console.error("Error submitting inquiry:", error);
    }
  };


  const courseOptions = coursesdata?.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const stateOptions = statedata?.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const cityOptions = cityData?.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  return (
   <section className="Common_Form">
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className="form-detail">
          <Col sm={6}>
            <Form.Group controlId="formGridname" className="mb-3">
              {/* <Form.Label>Full Name</Form.Label> */}
              <Form.Control
                name="name"
                className={classNames("", {
                  "is-invalid": errors?.name,
                })}
                type="text"
                {...register("name", {
                  required: "Name is required",
                  pattern: {
                    value: /^[A-Za-z ]*$/,
                    message: "Name must contain only letters",
                  },
                })}
                onKeyDown={(event) => {
                  if (!/[A-Z-a-z ]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                placeholder="Full Name"
              />

              {errors?.name && (
                <div className="invalid-feedback">{errors.name.message}</div>
              )}
            </Form.Group>
          </Col>
          <Col sm={6}>
            <Form.Group controlId="formGridphone" className="mb-3">
              {/* <Form.Label>Mobile Number</Form.Label> */}
              <Form.Control
                className={classNames("", {
                  "is-invalid": errors?.contact_no,
                })}
                type="tel"
                {...register("contact_no", {
                  required: "Contact No Number is required",
                  pattern: {
                    value: /^\d{10}$/,
                    message: "Contact No number must be a 10-digit number",
                  },
                  maxLength: 10,
                })}
                onKeyDown={(event) => {
                  const key = event.key;
                  if (
                    !/^\d$/.test(key) &&
                    ![
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                      "Home",
                      "End",
                    ].includes(key)
                  ) {
                    event.preventDefault();
                  }
                }}
                placeholder="Mobile Number"
                maxLength={10}
              />
              {errors?.contact_no && (
                <div className="invalid-feedback">
                  {errors.contact_no.message}
                </div>
              )}
            </Form.Group>
          </Col>
          <Col sm={6}>
            <Form.Group controlId="formGridemail" className="mb-3">
              {/* <Form.Label>Email Address</Form.Label> */}
              <Form.Control
                className={classNames("", {
                  "is-invalid": errors?.email,
                })}
                type="email"
                {...register("email", {
                  required: "E-mail is required",
                  pattern: {
                    value: /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z]{2,4})\.\2)([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
                    message: "Invalid E-Mail Address",
                  },
                })}
                placeholder="Email"
              />
              {errors?.email && (
                <div className="invalid-feedback">{errors.email.message}</div>
              )}
            </Form.Group>
          </Col>
          <Col sm={6}>
            <Form.Group controlId="formGridcourse" className="mb-3">
              {/* <Form.Label>Courses</Form.Label> */}
              <div className={classNames("react-select-wrapper", {
                "is-invalid": errors?.course_id,
              })}>
                <Select
                  options={courseOptions}
                  placeholder="Select Course"
                  onChange={(selected) => {
                    setValue("course_id", selected?.value);
                  }}
                />
              </div>
              {errors?.course_id && (
                <div className="invalid-feedback">
                  {errors.course_id.message}
                </div>
              )}
            </Form.Group>
          </Col>

          <Col sm={6}>
            <Form.Group controlId="formGridcourse" className="mb-3">
              {/* <Form.Label>State</Form.Label> */}

              <div className={classNames("react-select-wrapper", {
                "is-invalid": errors?.state_id,
              })}>

                <Select
                  options={stateOptions}
                  placeholder="Select State"
                  onChange={(selected) => {
                    setValue("state_id", selected?.value);
                    getCityData(selected?.value);
                  }}
                />
              </div>

              {/* <Form.Select
                aria-label="Default select example"
                className={classNames("", {
                  "is-invalid": errors?.state_id,
                })}
                {...register("state_id", {
                  required: "Please select a Course",
                })}
                onChange={(e) => {
                  const stateId = e.target.value;
                  getCityData(stateId);
                }}
              >
                <option value="">Select State</option>
                {statedata?.map((item, index) => (
                  <option key={index} value={item?.id}>
                    {item?.name}
                  </option>
                ))}
              </Form.Select> */}
              {errors?.state_id && (
                <div className="invalid-feedback">
                  {errors.state_id.message}
                </div>
              )}
            </Form.Group>
          </Col>

          <Col sm={6}>
            <Form.Group controlId="formGridcourse" className="mb-3">
              {/* <Form.Label>District</Form.Label> */}

              <div className={classNames("react-select-wrapper", {
                "is-invalid": errors?.district_id,
              })}>
                <Select
                  options={cityOptions}
                  placeholder="Select District"
                  onChange={(selected) => {
                    setValue("district_id", selected?.value);
                  }}
                />
              </div>
              {/* <Form.Select
                aria-label="Default select example"
                className={classNames("", {
                  "is-invalid": errors?.district_id,
                })}
                {...register("district_id", {
                  required: "Please select a Course",
                })}
              >
                <option value="">Select District</option>
                {cityData?.map((item, index) => (
                  <option key={index} value={item?.id}>
                    {item?.name}
                  </option>
                ))}
              </Form.Select> */}
              {errors?.district_id && (
                <div className="invalid-feedback">
                  {errors.district_id.message}
                </div>
              )}
            </Form.Group>
          </Col>

          <Col md={12}>
            <Form.Group controlId="formGridmessage" className="mb-3">
              {/* <Form.Label>Message</Form.Label> */}
              <Form.Control
                className={classNames("", {
                  "is-invalid": errors?.message,
                })}
                {...register("message", {
                  required: "Message is required",
                })}
                as="textarea"
                placeholder="Write Your Message Here..."
                rows={3}
              />
              {errors?.message && (
                <div className="invalid-feedback">{errors.message.message}</div>
              )}
            </Form.Group>
          </Col>
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Check
                required
                name="group1"
                type="checkbox"
                id="authorizeMsg"
                label={
                  <label htmlFor="authorizeMsg">
                    I hereby authorize you to send notifications via SMS/RCS
                    Messages/Promotional/Informational Messages
                  </label>
                }
              />
            </Form.Group>
          </Col>
        </Row>
        <div className="button-holder">
          <Button className="apply_btn" type="submit">
            Apply
          </Button>
        </div>
      </Form>
    </section>
  );
};

export default Common_Form;